"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdFooter = _interopRequireDefault(require("cccisd-footer"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FooterForm = function FooterForm(props) {
  var footer = props.fields.footer;
  var initialValues = props.initialValues;
  var _useState = (0, _react.useState)(!footer.copyrightYear.value),
    _useState2 = _slicedToArray(_useState, 2),
    useCurrentYear = _useState2[0],
    setUseCurrentYear = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!('footer' in props.settings)) {
      props.updateSettings(_objectSpread(_objectSpread({}, props.settings), {}, {
        footer: _objectSpread({}, initialValues)
      }));
    }
  }, [props.settings]);
  return /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: "Footer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-warning col-10"
  }, /*#__PURE__*/_react["default"].createElement("label", null, "Preview:"), /*#__PURE__*/_react["default"].createElement(_cccisdFooter["default"], {
    backgroundColor: footer.backgroundColor.value,
    className: _style["default"].footer,
    copyrightAttribution: footer.copyrightAttribution.value,
    copyrightYear: footer.copyrightYear.value,
    grantAttribution: footer.grantAttribution.value,
    showPolicyLinks: !!footer.showPolicyLinks.value,
    showContactUsLink: !!footer.showContactUsLink.value,
    showTermsLink: !!footer.showTermsAndConditionsLink.value,
    showPolicyLink: !!footer.showPrivacyPolicyLink.value,
    contactUsLink: footer.contactUsLink.value,
    termsLink: footer.termsLink.value,
    policyLink: footer.policyLink.value
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].block + ' col-6'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label"
  }, "Background Color:"), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.ColorPicker, {
    field: footer.backgroundColor
  })), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Copyright Attribution:",
    field: footer.copyrightAttribution
  }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Grant Attribution:",
    field: footer.grantAttribution
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].indented_bottom
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: useCurrentYear,
    onChange: function onChange(val) {
      var currentToggleValueAsString = val.target.value;
      var NewToggledValue = !(currentToggleValueAsString === 'true');
      setUseCurrentYear(NewToggledValue);
      footer.copyrightYear.onChange('');
    },
    label: "Use Current Year"
  })), !useCurrentYear && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].indented
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    wrapperClassName: "mb-1",
    label: "Copyright Year:",
    field: footer.copyrightYear
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "badge bg-info"
  }, "Leave blank to always show current year")), /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: !!footer.showPolicyLinks.value,
    onChange: function onChange() {
      footer.showPolicyLinks.onChange(!footer.showPolicyLinks.value);
    },
    label: "Show Policy Links"
  }), footer.showPolicyLinks.value && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].indented
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: !!footer.showContactUsLink.value,
    onChange: function onChange() {
      footer.showContactUsLink.onChange(!footer.showContactUsLink.value);
    },
    label: "Show Contact Us Link"
  }), footer.showContactUsLink.value && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    wrapperClassName: "mb-1",
    label: "Contact Us URL:",
    field: footer.contactUsLink
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "badge bg-info"
  }, "Leave blank to use default url"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: !!footer.showTermsAndConditionsLink.value,
    onChange: function onChange() {
      return footer.showTermsAndConditionsLink.onChange(!footer.showTermsAndConditionsLink.value);
    },
    label: "Show Terms And Conditions Link"
  }), footer.showTermsAndConditionsLink.value && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    wrapperClassName: "mb-1",
    label: "Terms and Conditions URL:",
    field: footer.termsLink
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "badge bg-info"
  }, "Leave blank to use default url"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: !!footer.showPrivacyPolicyLink.value,
    onChange: function onChange() {
      return footer.showPrivacyPolicyLink.onChange(!footer.showPrivacyPolicyLink.value);
    },
    label: "Show Privacy Policy Link"
  }), footer.showPrivacyPolicyLink.value && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    wrapperClassName: "mb-1",
    label: "Privacy Policy URL:",
    field: footer.policyLink
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "badge bg-info"
  }, "Leave blank to use default url"))))));
};
var _default = exports["default"] = FooterForm;